export const SMALL_DEVICE = {
  height: '1000px',
  width: '600px',
}

export const MEDIUM_DEVICE = {
  height: '1000px',
  width: '1000px',
}